import { Icon } from '@iconify/react';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'left',
  padding: theme.spacing(2, 2),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.secondary.lighter
}));


// ----------------------------------------------------------------------


export default function Applatestonlinetime(props) {
  return (
    <RootStyle>
      <Typography variant="h5">
      {props.title} <Icon icon="carbon:time" width={24} height={24} />
      </Typography>
      <Typography variant="h5">
      {props.state}
      </Typography>
    </RootStyle>
  );
}
